// extracted by mini-css-extract-plugin
export default {"formContainer":"PopUp_formContainer__4-K0K","section":"PopUp_section__Hj7J6","message":"PopUp_message__pdlkf","btnRow":"PopUp_btnRow__KD-Pg"};